<template>
  <div 
    id="frame-image-container"
    :style="{ 'width': relativeWidth + 'px', 'height': relativeHeight + 'px' }"
    class="top-left">
    <img 
      v-if="activeEvent"
      id="frame-image"
      :src="imgSrc"
      :width="relativeWidth + 'px'"
      :hight="relativeHeight + 'px'"
      class="top-left">
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { findFile } from '../lib/functions'

export default {
  name: 'FrameImage',
  computed: {
    ...mapState(['files']),
    ...mapGetters(['relativeWidth', 'relativeHeight', 'activeEvent']),
    imgSrc() {
      if (this.activeEvent) {
        const file = findFile(this.files, this.activeEvent.image)
        return window.URL.createObjectURL(file)
      }
    },
  },
}
</script>

<style lang="scss">
#frame-image-container,
#frame-image {
  z-index: 0;
}
</style>
